import * as React from "react";
import styled from "styled-components";
import GameRule from "./Types/GameRule";
import DraggableCard from "./DraggableCard";
import TimeLimit from "./TimeLimit";
import { GameState } from "./Types/Game";

interface Props {
  gameState: GameState;
  cards: number[];
  selectedCard?: number;
  isMyTurn?: boolean;
  gameRule: GameRule;
  isTimeLimitEnabled: boolean;
  handleCardIsBeingDragged: (i: number) => () => void;
  handleCardIsNotBeingDragged: () => void;
  handleAutomaticCardPlayed: () => void;
  gameId: number;
}

const StyledCardContainer = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-auto-flow: column;
  font-size: 5vw;
  margin-top: 3rem;
`;

const CardContainer = ({
  gameState,
  cards,
  selectedCard,
  isMyTurn,
  gameRule,
  isTimeLimitEnabled,
  handleCardIsBeingDragged,
  handleCardIsNotBeingDragged,
  handleAutomaticCardPlayed,
  gameId
}: Props) => {
  return (
    <>
      {gameState === "started" && isTimeLimitEnabled && isMyTurn && (
        <TimeLimit
          handleAutomaticCardPlayed={handleAutomaticCardPlayed}
          cards={cards}
        />
      )}
      <StyledCardContainer>
        {cards.map((c, i) => (
          <DraggableCard
            onClick={() => false}
            isAnyCardSelected={selectedCard !== undefined}
            selected={selectedCard === c}
            key={c}
            enabled={isMyTurn}
            isHighlighted={true}
            number={c}
            gameRule={gameRule}
            onBegin={handleCardIsBeingDragged(c)}
            onEnd={handleCardIsNotBeingDragged}
            gameId={gameId}
          >
            {c}
          </DraggableCard>
        ))}
      </StyledCardContainer>
    </>
  );
};
export default CardContainer;
